import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi, OpalApiResponseDocument } from '../../schema'

type ReadStampsV2 = OpalApi<'ReadStampsV2', 200>
type ReadStampsV2ResponseData = OpalApiResponseDocument<'ReadStampsV2', 200>

export const readStamps: ReadStampsV2 = async ({
  params,
}: Parameters<ReadStampsV2>[0] = {}) => {
  const url = new URL('/stamps/v2', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadStampsV2ResponseData>(url.toString())
    .then((res) => res.data)
}
